import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CS_BASE_URL } from '../utils/ProjectUrls';
import { MultiOctoPartsResponse } from '../schemas/MultiOctoPartsResponse';
import { OctoPartRequest } from '../schemas/OctoPartRequest';

const MULTI_PARTS_PATH = '/octopart/multiparts';

// 使用createApi创建一个新的API slice
// Use createApi to create a new API slice
export const multiPartSlice = createApi({
    reducerPath: 'multiparts',
    // Set the base URL for API requests
    baseQuery: fetchBaseQuery({ baseUrl: CS_BASE_URL }),

    // Define the API endpoints
    endpoints: (builder) => ({
        // Define a query endpoint for fetching uniquepart data
        getOctoMultiPart: builder.query<MultiOctoPartsResponse[], OctoPartRequest[]>({
            // Specify the specific path for the request
            query: (body: OctoPartRequest[]) => ({
                url: MULTI_PARTS_PATH,
                method: 'POST',
                body,
            }),
        }),
        // More endpoints can be added here
    }),
});

// Export the auto-generated hook from the definitionSlice
export const { useLazyGetOctoMultiPartQuery } = multiPartSlice;
